<div class="relative flex h-[480px] w-[420px] max-w-lg flex-col rounded-2xl bg-background-white/40 p-5 pb-6 shadow-modal backdrop-blur-modal">
  <!-- Fixed Header with Title and Close Button -->
  <div class="flex items-center justify-between pb-6">
    <h2 class="text-xl font-semibold text-text-primary">
      {{ 'schedule_legend_title' | translate }}
    </h2>
    <button class="flex h-6 w-6 items-center justify-center rounded-full" (click)="onCloseDialog()" type="button">
      <svg-icon key="px-16-x" class="h-6 w-6 text-primary-blue" />
    </button>
  </div>

  <!-- Scrollable Content -->
  <div class="-mr-3 flex-1 overflow-y-auto pr-3">
    <div>
      <!-- Appointment Card Example -->
      <div class="mb-6">
        <img src="assets/images/schedule_legend_v2.png" [alt]="'schedule_legend_appointment_card_example' | translate" class="w-full" />
      </div>

      <!-- Appointment Status List -->
      <div class="mb-6">
        <h3 class="typo-h7-semibold mb-3 text-text-primary">
          {{ 'schedule_legend_appointment_status' | translate }}
        </h3>
        <div class="grid grid-cols-1 gap-x-4 gap-y-[6px]">
          @for (status of appointmentStatusColors; track status.dxStatusId) {
            <div class="flex items-end gap-[2px]">
              <div class="mb-[1px] h-[10px] w-1 flex-shrink-0" [style.background-color]="convertToHexColor(status)"></div>
              <span
                #statusCode
                class="typo-h7-book max-w-[162px] truncate uppercase text-text-primary"
                [libUiTooltip]="statusCode.scrollWidth > statusCode.offsetWidth ? codeTooltip : undefined"
                [tooltipContext]="{ text: getStatusCode(status) }"
                tooltipPosition="top"
              >
                {{ getStatusCode(status) }}
              </span>
              <div class="mx-1 mb-[3px] h-px flex-1 bg-text-extra-light"></div>
              <span
                #statusName
                class="typo-h7-light max-w-[162px] truncate text-right font-light text-text-secondary"
                [libUiTooltip]="statusName.scrollWidth > statusName.offsetWidth ? nameTooltip : undefined"
                [tooltipContext]="{ text: status.statusName }"
                tooltipPosition="top"
              >
                {{ status.statusName }}
              </span>
            </div>
          } @empty {
            <span class="typo-h9-light"> - </span>
          }
        </div>
      </div>

      <!-- Provider List -->
      <div class="mb-6">
        <h3 class="typo-h7-semibold mb-3 text-text-primary">
          {{ 'schedule_legend_providers' | translate }}
        </h3>
        <div class="grid grid-cols-1 gap-x-4 gap-y-[6px]">
          @for (provider of providers; track provider.id) {
            <div class="flex items-end gap-[2px]">
              <div
                class="mb-[1px] h-[10px] w-[8px] rounded-[4px_1px_1px_1px]"
                [style.background-color]="formatProviderColor(provider.color)"
              ></div>
              <span
                #providerCode
                class="typo-h7-book max-w-[162px] truncate uppercase text-text-primary"
                [libUiTooltip]="providerCode.scrollWidth > providerCode.offsetWidth ? codeTooltip : undefined"
                [tooltipContext]="{ text: provider | pmsDisplayCode }"
                tooltipPosition="top"
              >
                {{ provider | pmsDisplayCode }}
              </span>
              <div class="mx-1 mb-[3px] h-px flex-1 bg-text-extra-light"></div>
              <span
                #providerName
                class="typo-h7-light max-w-[162px] truncate text-right font-light text-text-secondary"
                [libUiTooltip]="providerName.scrollWidth > providerName.offsetWidth ? nameTooltip : undefined"
                [tooltipContext]="{ text: provider.firstName + ' ' + provider.lastName }"
                tooltipPosition="top"
              >
                {{ provider.firstName }} {{ provider.lastName }}
              </span>
            </div>
          } @empty {
            <span class="typo-h9-light"> - </span>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Gradient Bottom -->
  <div class="absolute bottom-0 left-0 right-0 h-12 rounded-b-2xl bg-gradient-to-b from-transparent to-background-white"></div>
</div>

<ng-template #codeTooltip let-context>
  <div class="typo-h7-book p-2 uppercase">{{ context.text }}</div>
</ng-template>

<ng-template #nameTooltip let-context>
  <div class="typo-h7-light p-2 font-light">{{ context.text }}</div>
</ng-template>
